// Slow editorial marquee strip.
export default function Marquee({
  items,
  dark = false,
  className = "",
}) {
  const reps = Math.max(2, Math.ceil(12 / items.length));
  const base = Array.from({ length: reps }, () => items).flat();
  const track = [...base, ...base];
  return (
    <div
      className={`relative overflow-hidden border-y ${
        dark ? "border-white/10 bg-charcoal" : "border-gold/20 bg-cream-deep"
      } ${className}`}
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-10 py-5">
        {track.map((item, i) => (
          <div key={i} className="flex items-center gap-10">
            <span
              className={`font-serif lining-nums text-2xl md:text-3xl italic ${
                dark ? "text-cream" : "text-ink"
              }`}
            >
              {item}
            </span>
            <span className="text-gold text-xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
